export default "__VITE_ASSET__BC313KG5__"